import "../../../styles/stores/expenses/expenseSkeleton.css";

const ExpenseLoadingSkeleton = () => {
  const skeletonCards = [
    { type: "marketing", delay: "0s" },
    { type: "rent", delay: "0.1s" },
    { type: "salary", delay: "0.2s" },
    { type: "bills", delay: "0.3s" },
    { type: "repairs", delay: "0.4s" },
    { type: "ads", delay: "0.5s" },
    { type: "tax", delay: "0.6s" },
    { type: "others", delay: "0.7s" },
  ];

  return (
    <div className='expense-skeleton-container'>
      <div className='expense-skeleton-wrapper'>
        {/* Header Section */}
        <div className='expense-skeleton-header'>
          <div className='expense-skeleton-title-section'>
            <div className='expense-skeleton-title'>
              <div className='expense-skeleton-shimmer' style={{ animationDelay: "0s" }}></div>
            </div>
            <div className='expense-skeleton-subtitle'>
              <div className='expense-skeleton-shimmer' style={{ animationDelay: "0.2s" }}></div>
            </div>
          </div>
          <div className='expense-skeleton-button'>
            <div className='expense-skeleton-shimmer' style={{ animationDelay: "0.4s" }}></div>
          </div>
        </div>

        {/* Cards Grid */}
        <div className='expense-skeleton-grid'>
          {skeletonCards.map((card, index) => (
            <div key={index} className='expense-skeleton-card'>
              <div className='expense-skeleton-card-header'>
                <div className={`expense-skeleton-icon expense-skeleton-icon-${card.type}`}>
                  <div className='expense-skeleton-shimmer' style={{ animationDelay: card.delay }}></div>
                </div>
                <div className='expense-skeleton-card-content'>
                  <div className='expense-skeleton-card-title'>
                    <div className='expense-skeleton-shimmer' style={{ animationDelay: card.delay }}></div>
                  </div>
                  <div className='expense-skeleton-card-desc'>
                    <div className='expense-skeleton-shimmer' style={{ animationDelay: card.delay }}></div>
                  </div>
                </div>
              </div>
              <div className='expense-skeleton-amount'>
                <div className='expense-skeleton-shimmer' style={{ animationDelay: card.delay }}></div>
              </div>
            </div>
          ))}
        </div>

        {/* Total Section */}
        <div className='expense-skeleton-total-section'>
          <div className='expense-skeleton-total-label'>
            <div className='expense-skeleton-shimmer' style={{ animationDelay: "0.8s" }}></div>
          </div>
          <div className='expense-skeleton-total-amount'>
            <div className='expense-skeleton-shimmer' style={{ animationDelay: "1s" }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpenseLoadingSkeleton;
